module.exports = "<div ng-click=\"showOffersButton.onClick($event)\" class=\"filter-show-button s-button s-button_size_s s-button_solid s-button_action\"><cian-ui-preloader muted=\"true\" size=\"20\" ng-show=\"showOffersButton.isLoading\"></cian-ui-preloader><div ng-switch=\"showOffersButton.isNewQuery\" class=\"s-button__text\"><ng-pluralize ng-switch-when=\"true\" count=\"showOffersButton.count\" when=\"showOffersButton.pluralForms\"></ng-pluralize><span ng-switch-default=\"ng-switch-default\">Показать объекты</span></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/serp/directives/show-offers-button/show-offers-button.jade
// module id = 1015
// module chunks = 0